<template>
    <section>
        <div class="thread_div" v-if="thread_info.length!=0">
            <div class="thread_head">
                <p>{{ thread_info.date }}</p>
                <p>{{ '作成者名' }}</p>
                <p @click="addFavorite(0)">いいね！：{{ thread_info.lgtm }}</p>
                <p>コメント数：{{ thread_info.comment }}</p>
            </div>
            <div class="thread_title">
                <p>{{ thread_info.title }}</p>
            </div>
            <div class="thread_content">
                <p v-html="thread_info.content"></p>
            </div>
        </div>
        <div class="comment_div">
            <div class="">
                <textarea v-model="comment_str" placeholder="コメント入力"></textarea>
                <button @click="postComment(0)">投稿する</button>
            </div>
            <div class="comment_body" v-for="comment in comment_list">
                <div class="comment_img">
                    <img class="user_img" :src="comment.icon" style="width:4rem; object-fit: contain;">
                </div>
                <div class="comment_fukidashi">
                    <p class="comment_username">投稿者名：{{ comment.name }}</p>
                    <p class="comment_content" v-html="comment.content"></p>
                </div>
                <div class="comment_footer">
                    <p class="comment_lgtm" @click="addFavorite(comment.comment_id)">いいね！：{{ comment.lgtm }}</p>
                    <p class="comment_reply" @click="openReplyModal(comment.comment_id)">{{ '返信' }}</p><p class="comment_time">{{ comment.date }}</p>
                </div>
            </div>
        </div>
        <div>
            <p>返信する</p>
            <p>返信先：{{ reply_id }}</p>
            <textarea v-model="reply_str" placeholder="コメント入力"></textarea>
            <button @click="postReply()">返信する</button>
        </div>
    </section>
</template>

<script>
    export default {
        name: "thread-list",
        props: ['thread_id', 'json_characters'],
        data: function () {
            return {
                comment_str: '',
                reply_str: '',
                thread_info: [],
                comment_list: [],
                reply_id: 0,
                characters: Object,
            }
        },
        mounted() {
            this.getThreadInfo();
            this.getComment();
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            getThreadInfo: function () {
                axios.default
                    .get(`/thread/info?thread_id=${this.thread_id}`)
                    .then(response => {
                        if(response.data.status==1) {
                            this.thread_info = response.data.thread;
                        } else {
                            alert(this.characters[response.data.msg]);
                            window.location = "/thread";
                            return;
                        }
                    });
            },
            getComment: function () {
                axios.default
                    .get(`/comment/list?thread_id=${this.thread_id}`)
                    .then(response => {
                        if(this.comment_list.length == 0) {
                            this.comment_list = response.data;
                        } else {
                            this.comment_list = this.comment_list.concat(response.data);
                        }
                    });
            },
            postComment: function(comment_id) {
                axios.default
                    .post(`/comment/add`, {thread_id: this.thread_id, comment_id: comment_id, comment: this.comment_str})
                    .then(response => {
                        let res = response.data;
                        console.log(res);
                    });
            },
            postReply: function() {
                const comment_id = this.reply_id;
                axios.default
                    .post(`/comment/add`, {thread_id: this.thread_id, comment_id: comment_id, comment: this.reply_str})
                    .then(response => {
                        let res = response.data;
                        console.log(res);
                    });
            },
            openReplyModal(comment_id) {
                this.reply_id = comment_id;
            },
            addFavorite: function(comment_id) {
                axios.default
                    .post(`/thread/favorite/add`, {thread_id: this.thread_id, comment_id: comment_id})
                    .then(response => {
                        let res = response.data;
                        console.log(res);
                    });
            },
        }
    }
</script>

<style scoped>

</style>
